<template>
  <tr>
    <th>
      {{ value.entidad}}
      <a v-bind:href="value.url">
        <span class="icon is-small">
          <font-awesome-icon icon="external-link-alt" />
        </span>
      </a>
    </th>
    <td>{{ formattedCompra }}</td>
    <td>{{ formattedVenta }}</td>
    <td v-bind:title="formattedActualizado">{{ timeSince }}</td>
  </tr>
</template>

<script>
import readableTime from '../services/readableTime'
import currencyFormat from '../services/currencyFormat'
export default {
  name: 'CotizrRow',
  props: {
    value: Object
  },
  data () {
    return {
      now: new Date(),
      timer: undefined
    }
  },
  created () {
    this.timer = setInterval(this.updateNow, 60000)
  },
  methods: {
    updateNow () {
      this.now = new Date()
    }
  },
  computed: {
    formattedCompra () {
      return currencyFormat.format(this.value.compra)
    },
    formattedVenta () {
      return currencyFormat.format(this.value.venta)
    },
    formattedActualizado () {
      const date = new Date(this.value.actualizado)
      return `${date.toLocaleDateString()}, ${date.toLocaleTimeString()}`
    },
    timeSince () {
      return readableTime.between(new Date(), new Date(this.value.actualizado))
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss">
</style>
